<ion-header mode="md">
  <ion-toolbar color="clear">
    <ion-title>{{ 'property.enquire_now' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="modalController.dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding content" [fullscreen]="true">
  <form [formGroup]="form" (submit)="sendRequest()">
    <ion-item lines="none">
      <ion-img slot="start" [src]="property?.imageList[0].filepath"></ion-img>
      <ion-label>
        <h3>{{property?.titleEn}}</h3>
        <p>{{property?.address.subCityEn}}, {{property?.address.cityEn}}</p>
        <h2>{{property?.price | currency: 'SAR '}}</h2>
      </ion-label>
    </ion-item>
    @if (!user) {
      <ion-label>{{ 'property.form.name' | translate }} *</ion-label>
      <ion-input [errorText]="'property.form.mandatory' | translate"
                 fill="outline" mode="md"
                 formControlName="name"
                 placeholder="e.g Ali"
      ></ion-input>

      <ion-label>{{ 'property.form.email' | translate }} *</ion-label>
      <ion-input [errorText]="'property.form.mandatory' | translate"
                 fill="outline" mode="md"
                 placeholder="youremail@email.com"
                 formControlName="email" type="email"></ion-input>

      <app-select-country [userInput]="prefix" (countrySelected)="countrySelected($event)"></app-select-country>
      <ion-label>{{ 'property.form.phone' | translate }} *</ion-label>
      <ion-input [errorText]="'property.form.mandatory' | translate"
                 fill="outline" mode="md"
                 placeholder="00 000 0000"
                 formControlName="contactNumber">
        <span slot="start">{{prefix}}</span>
      </ion-input>
    }
    <ion-label>{{ 'property.form.lease_duration' | translate }} *</ion-label>
    <ion-select fill="outline" mode="md"
                [dir]="languageService.dir()"
                [lang]="languageService.lang()"
                interface="popover"
                [placeholder]="'property.select_lease_duration' | translate"
                aria-label="{{ 'property.form.lease_duration' | translate }}"
                formControlName="leaseDuration">
      @for (duration of formTextContent?.durationDropDown; track duration) {
        <ion-select-option [value]="duration">{{ duration }}</ion-select-option>
      }
    </ion-select>
    <ion-label>{{ 'property.form.move_in_date' | translate }} *</ion-label>
    <ion-input fill="outline" mode="md"
               [readonly]="true"
               formControlName="moveInDate"
               [errorText]="'property.form.mandatory' | translate"
               label-placement="floating">
      <ion-buttons slot="end">
        <ion-button id="datetime" aria-label="{{ 'property.form.move_in_date' | translate }}">
          <ion-icon name="calendar-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-input>

    <ion-modal #dateTimePicker
               class="date-picker-model"
               trigger="datetime" [keepContentsMounted]="true">
      <ng-template>
        <div class="ion-padding">
          <ion-datetime (ionChange)="datePicked($event); dateTimePicker.dismiss()"
                        presentation="date" mode="md"></ion-datetime>
        </div>
      </ng-template>
    </ion-modal>

    <ion-label>{{ 'property.form.message' | translate }} *</ion-label>
    <ion-textarea
      style="height: 100px"
      [errorText]="'property.form.mandatory_error' | translate"
      fill="outline"
      mode="md"
      [placeholder]="'property.details_difference' | translate"
      formControlName="message"></ion-textarea>
  <div class="ion-padding"></div>
    <ion-button shape="round" type="submit">{{ 'property.form.submit' | translate }}</ion-button>
    <ion-button color="clear" fill="outline" (click)="modalController.dismiss()">{{ 'property.cancel' | translate }}</ion-button>
  </form>
</ion-content>
